import { useContext, useEffect } from 'react';
import { UserInfoContext } from '@/contexts/UserInfoContext';
import * as Sentry from '@sentry/react';

/**
 * Component that synchronizes UserInfo context with Sentry user context.
 * Sets Sentry user data when user is logged in, clears it when logged out.
 */
export const SentryUserSync = () => {
  const { userInfo } = useContext(UserInfoContext);

  useEffect(() => {
    // Check if Sentry is properly initialized
    try {
      const client = Sentry.getClient();
      if (!client) {
        return;
      }
    } catch (error) {
      return;
    }

    if (userInfo) {
      // User is logged in - set Sentry user context
      Sentry.setUser({
        id: userInfo.id,
        email: userInfo.email,
        username: userInfo.name,
        // Optional additional context specific to Devo
        ip_address: undefined, // Let Sentry auto-detect
      });

      // Set additional tags for better filtering
      Sentry.setTag('devoDomain', userInfo.devoDomain);
      if (userInfo.theme) {
        Sentry.setTag('theme', userInfo.theme);
      }
    } else {
      // User is logged out - clear Sentry user context
      Sentry.setUser(null);

      // Clear relevant tags
      Sentry.setTag('devoDomain', null);
      Sentry.setTag('theme', null);
    }
  }, [userInfo]);

  // This component doesn't render anything
  return null;
};
